import dynamic from "next/dynamic";
import Loading from "@/components/common/Loading";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const RestaurantIndustry = dynamic(() => import('../../components/indPages/restaurants/DesktopRestaurants'), {
   loading: () => <Loading />
 });
 
 const MobileRestaurantIndustry = dynamic(() => import('../../components/indPages/restaurants/MobileRestaurants'), {
   loading: () => <Loading />
 });

const Restaurant = ({ mobileView }) => {
   return (
      <>
         <Head>
            <title>Free Restaurant Billing Software | Fine Dine POS Billing Solutions</title>
            <meta name="description" content="Optimize your restaurant billing process with advanced POS billing software. Perfect for both fine dine and casual dining establishments. Check out the features or take a trial today!" />
            <link rel="canonical" href="https://queuebuster.co/Industries/restaurant-pos-billing-software" />
            <link rel="alternate" href="https://queuebuster.co/Industries/restaurant-pos-billing-software" hrefLang="en-us" />
            <meta property="og:title" content="Free Restaurant Billing Software | Fine Dine POS Billing Solutions" />
            <meta property="og:description" content="Optimize your restaurant billing process with advanced POS billing software. Perfect for both fine dine and casual dining establishments. Check out the features or take a trial today!" />
            <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/og-restaurant.jpg" />
            <meta property="og:url" content="https://queuebuster.co/Industries/restaurant-pos-billing-software" />
         </Head>
         <SchemaTags page="restaurant-pos-billing-software" />
         {mobileView ? <MobileRestaurantIndustry /> : <RestaurantIndustry />}
      </>
   );
};

export default Restaurant;
